import applicationStore from '@/store/modules/applications/applicationStore'
import { Vue, Component } from 'vue-property-decorator'
import DashboardLeftPanel from './dashboardLeftPanel/DashboardLeftPanel.vue'

@Component({
  components: {
    'dashboard-left-panel': DashboardLeftPanel
  }
})
export default class DashboardContainer extends Vue {
  /* istanbul ignore next */
  destroyed() {
    applicationStore.mutateProgramsSitesArry([])
    applicationStore.MutateWailistDeniedApplications([])
    applicationStore.mutateScholarsList('')
  }
}
